<template>
  <v-main class="bg-background" scrollable>
    <div class="so-page-with-header" data-testid="so-page-with-header">
      <header
        v-if="$slots.header || title"
        class="so-page-with-header__header d-flex flex-column align-center pa-12"
        :style="darkHeaderBgColor ? getHeaderBackgroundStyle : getHeaderStyle"
      >
        <SoContainer
          v-if="isSearchPage"
          :class="theme.isDark ? 'text-black' : 'text-white'"
          class="d-flex align-center pr-0"
        >
          <SoCol :default-width="5">
            <h1 v-if="title" class="text-capitalize pb-4 title">
              {{ title }}
            </h1>
            <h5 v-if="metaDescription" class="font-weight-bold">
              {{ metaDescription }}
            </h5>
          </SoCol>
          <SoCol :default-width="7">
            <slot name="header"></slot>
          </SoCol>
        </SoContainer>
        <SoRow v-else class="align-center">
          <SoIcon
            v-if="icon"
            :icon="icon"
            :color="darkHeaderBgColor && !theme.isDark ? 'white' : 'black'"
            :size="'x-large'"
            class="mr-5 font-weight-bold so-page-with-header-icon"
          />
          <h1
            v-if="title"
            :class="
              darkHeaderBgColor && !theme.isDark ? 'text-white' : 'text-black'
            "
            class="text-uppercase text-center my-8"
          >
            {{ title }}
          </h1>
          <slot name="header"></slot>
        </SoRow>
      </header>

      <div class="ma-4">
        <slot></slot>
      </div>
    </div>
  </v-main>
</template>

<script lang="ts">
  import { useThemeHelper } from "@/theme/themeHelper"
  import { defineComponent, PropType } from "vue"
  import SoIcon from "@/components/SoIcon.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import { IconStringWithModifiers } from "@/types/Icon"

  export default defineComponent({
    components: { SoContainer, SoRow, SoCol, SoIcon },
    props: {
      isSearchPage: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: null,
      },
      metaDescription: {
        type: String,
        default: null,
      },
      darkHeaderBgColor: {
        type: Boolean,
        default: false,
      },
      headerBg: {
        type: String,
        default: null,
      },
      headerBgDark: {
        type: String,
        default: null,
      },
      icon: {
        type: String as PropType<IconStringWithModifiers>,
        default: null,
      },
    },
    data() {
      return {
        theme: useThemeHelper(),
      }
    },
    computed: {
      getHeaderStyle() {
        if (!this.headerBg) return {}
        return {
          backgroundImage: this.theme.isDark
            ? `url(${this.headerBgDark})`
            : `url(${this.headerBg})`,
        }
      },
      getHeaderBackgroundStyle() {
        return {
          backgroundColor: this.theme.isDark
            ? this.headerBgDark
            : this.theme.colors.black,
        }
      },
    },
  })
</script>

<style scoped>
  .so-page-with-header__header {
    background-color: rgb(var(--v-theme-primary));
    background-size: cover;
    background-position: center center;
  }
  :deep(.title) {
    font-size: 3.1rem !important;
    line-height: 3.1rem !important;
  }
</style>
